import React from 'react';
import styled from 'styled-components';
import { Title } from './MemberSetting';
import { useSetting } from '../../shared/hooks/useApi/useSetting';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { popIn } from '../../shared/component/Animation';
import { BlackFullWidthBtn } from '../../shared/component/headless/button/BtnBody';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import deleteIcon from '../../asset/icon/delete.png';
import { usePayment } from '../../shared/hooks/useApi/usePayment';
import { getModalMessage } from '../../shared/constants/modalMessages';
import { getBtnName } from '../../shared/constants/btnNames';
import { paperTextureModal } from '../../shared/component/paperTexture';

const JoinWaitlistModal: React.FC = () => {
  const { user } = useAuth();
  const { setting } = useSetting();
  const { standardModal, isClosing, clearModal } = useModalStore();
  const { requestAccess } = usePayment();


  if (!setting || standardModal == null || !user) return null;

  const handleRequestAccess = async () => {
    await requestAccess();
  }

  const handleClose = () => {
    clearModal();
  };

  return (
    <JoinWaitlistModalFrame
      onClick={(e) => e.stopPropagation()}
      $isClosing={isClosing}
    >
      <HeaderRow>
        <ModalTitle>{getModalMessage('ACCESS_BY_INVITATION_TITLE')}</ModalTitle>
        <UniversalIconBtn
          size="small"
          border={false}
          isTransparent
          hoverOpacity
          backgroundImg={deleteIcon}
          onClick={handleClose}
        />
      </HeaderRow>
      <JoinWaitlistComp>
        {getModalMessage('JOIN_WAITLIST_BODY')}
      </JoinWaitlistComp>
      <SubmitButton
        onClick={handleRequestAccess}>
        {getBtnName('REQUEST_ACCESS')}
      </SubmitButton>
    </JoinWaitlistModalFrame>
  );
}


export const JoinWaitlistModalFrame = styled.div<{ $isClosing: boolean }>`
  position: relative;
  padding: 30px 25px;
  width: 500px;
  height: fit-content;
  
  opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
  transform: ${({ $isClosing }) => ($isClosing ? 'scale(0.8)' : 'scale(1)')};
  
  transition: all 0.3s ease-in;
  ${paperTextureModal}
  ${popIn}
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const ModalTitle = styled(Title)`
  margin-bottom: 0;
`;

const JoinWaitlistComp = styled.div`
  padding: 30px 0px 50px 0px;
  ${({ theme }) => theme.typography.Body_02_2};
  color: ${({ theme }) => theme.colors.color_Gray_03};
  line-height: 1.5;
  white-space: pre-line;
`;

const SubmitButton = styled(BlackFullWidthBtn)`
  width: 100%;
  margin: 10px 0px 10px 0;
`;

export default JoinWaitlistModal;